import { Etasje } from '../../../../types/registration/userInput';

import { AboutFormData } from './form/types';

const kjellerEtasjeDefault: Etasje = {
  id: crypto.randomUUID(),
  erKjeller: true,
  etasjeNummer: 1
};

// The content of this file is a hack to generate floors in the client. This should be moved to backend.

export const generateEtasjer = (antallEtasjer: number, fromFloorNumber?: number) => {
  const etasjer = Array.from({ length: antallEtasjer }, (_, index) => ({
    id: crypto.randomUUID(),
    erKjeller: false,
    etasjeNummer: (fromFloorNumber || 0) + index + 1
  }));

  return etasjer;
};

export const updateEtasjer = (currentEtasjer: Etasje[], hasHeatedBasement: boolean, formData: AboutFormData) => {
  const hasHeatedBasementInForm = formData.bygginfo?.isHeatedBasement || false;
  const numberOfEtasjerFromForm = formData.bygginfo?.floors || 0;
  const existingBasement = currentEtasjer.find((e) => e.erKjeller);

  const hasBasementInState = !!existingBasement;

  // Filter out non-basement floors (main floors)
  const nonBasementFloors = currentEtasjer.filter((e) => !e.erKjeller);

  // No need to update if the number of etasjer and heated basement flag is the same
  if (nonBasementFloors.length === numberOfEtasjerFromForm && hasHeatedBasementInForm === hasBasementInState) {
    return currentEtasjer;
  }

  let updatedNonBasementFloors: Etasje[] = [];

  // If new etasje count is less than previous we remove excess etasjer
  if (numberOfEtasjerFromForm < nonBasementFloors.length) {
    updatedNonBasementFloors = nonBasementFloors.slice(0, numberOfEtasjerFromForm);
  }

  // If new etasje count is greater than previous we generate new etasje(s)
  else if (numberOfEtasjerFromForm > nonBasementFloors.length) {
    // Use number of main floors as a starting
    const startNumber = nonBasementFloors.length;

    updatedNonBasementFloors = [
      ...nonBasementFloors,
      ...generateEtasjer(numberOfEtasjerFromForm - nonBasementFloors.length, startNumber)
    ];
  }
  // If only the basement status changed
  if (numberOfEtasjerFromForm === nonBasementFloors.length && hasHeatedBasementInForm !== hasHeatedBasement) {
    updatedNonBasementFloors = [...nonBasementFloors];
  }

  // Always check if we need to add basement at the end
  if (hasHeatedBasementInForm) {
    // use currentBasement if any or default here to hinder early return of value
    const kjellerToUse = existingBasement || kjellerEtasjeDefault;
    const existingKjeller = { ...kjellerToUse, etasjeNummer: 1, erKjeller: true };

    return [existingKjeller, ...updatedNonBasementFloors];
  }

  return updatedNonBasementFloors;
};
